// EvenementDirectService.ts
import { AjouterMiseAJourDirectDto, CreerEvenementDirectDto } from "@/types/evenements-direct.types";
import API from "./api";


const EvenementDirectService = {
  getAll: async () => {
    const response = await API.get("/direct/evenements");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/direct/evenements/${id}`);
    return response.data.donnees;
  },

  create: async (payload: CreerEvenementDirectDto) => {
    const response = await API.post("/direct/evenements", payload);
    return response.data.donnees;
  },

  close: async (id: number) => {
    const response = await API.post(`/direct/evenements/${id}/fermer`);
    return response.data.donnees;
  },

  addUpdate: async (id: number, payload: AjouterMiseAJourDirectDto) => {
    const response = await API.post(
      `/direct/evenements/${id}/mises-a-jour`,
      payload
    );
    return response.data.donnees;
  },
};

export default EvenementDirectService;